<template> 
    <div class="motivation-container">
        <transition name="fade" mode="out-in">
            <div :key="currentIndex" class="motivation-phrase-content">
                <p class="motivation-phrase font-italic">{{ currentPhrase.frase }}</p>
                <p class="motivation-author font-weight-medium">- {{ currentPhrase.autor }}</p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'MotivationPhrases',
    data() {
        return {
            currentIndex: 0,
            motivationPhrases: [
                {
                    frase: "El estudio es la forja que nos permite convertirnos en lo que somos capaces de ser.",
                    autor: "Aristóteles"
                },
                {
                    frase: "La educación es el arma más poderosa que puedes usar para cambiar el mundo.",
                    autor: "Nelson Mandela"
                },
                {
                    frase: "La educación es el pasaporte hacia el futuro, el mañana pertenece a aquellos que se preparan para él en el día de hoy.",
                    autor: "Malcolm X"
                },
                {
                    frase: "El aprendizaje es como remar contra corriente: en cuanto se deja, se retrocede.",
                    autor: "Edward Benjamin Britten"
                },
                {
                    frase: "Lo maravilloso de aprender algo es que nadie puede arrebatárnoslo.",
                    autor: "B.B. King"
                },
                {
                    frase: "Invertir en conocimientos produce siempre los mejores intereses.",
                    autor: "Benjamin Franklin"
                },
                {
                    frase: "La disciplina es el puente entre las metas y los logros.",
                    autor: "Jim Rohn"
                },
                {
                    frase: "No es que no tengamos tiempo; es que perdemos demasiado.",
                    autor: "Séneca"
                },
                {
                    frase: "La excelencia no es un acto, sino un hábito.",
                    autor: "Aristóteles"
                },
                {
                    frase: "No hay viento favorable para el que no sabe a dónde va.",
                    autor: "Séneca"
                },
                {
                    frase: "El conocimiento no es aquello que posees, sino aquello que compartes.",
                    autor: "Platón"
                },
                {
                    frase: "Los analfabetos del siglo XXI no serán aquellos que no sepan leer y escribir, sino aquellos que no sepan aprender, desaprender y reaprender.",
                    autor: "Alvin Toffler"
                },
                {
                    frase: "Nunca consideres el estudio como una obligación, sino como una oportunidad para penetrar en el bello y maravilloso mundo del saber.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "El éxito es la suma de pequeños esfuerzos repetidos día tras día.",
                    autor: "Robert Collier"
                },
                {
                    frase: "Si crees que la educación es cara, prueba con la ignorancia.",
                    autor: "Derek Bok"
                },
                {
                    frase: "El aprendizaje no se alcanza por casualidad, debe buscarse con ardor y atenderse con diligencia.",
                    autor: "Abigail Adams"
                },
                {
                    frase: "La educación es lo que sobrevive cuando lo aprendido ha sido olvidado.",
                    autor: "B.F. Skinner"
                },
                {
                    frase: "No dejes que lo que no puedes hacer interfiera con lo que puedes hacer.",
                    autor: "John Wooden"
                },
                {
                    frase: "La educación no es preparación para la vida; la educación es la vida misma.",
                    autor: "John Dewey"
                },
                {
                    frase: "Dime y lo olvido, enséñame y lo recuerdo, involúcrame y lo aprendo.",
                    autor: "Benjamin Franklin"
                },
                {
                    frase: "Los grandes resultados requieren grandes ambiciones.",
                    autor: "Heráclito"
                },
                {
                    frase: "Lo que sabemos es una gota de agua; lo que ignoramos es el océano.",
                    autor: "Isaac Newton"
                },
                {
                    frase: "El que aprende y aprende y no practica lo que sabe, es como el que ara y ara y no siembra.",
                    autor: "Platón"
                },
                {
                    frase: "La única forma de hacer un gran trabajo es amar lo que haces.",
                    autor: "Steve Jobs"
                },
                {
                    frase: "Nuestra mayor debilidad radica en rendirnos. La forma más segura de tener éxito es siempre intentarlo una vez más.",
                    autor: "Thomas A. Edison"
                },
                {
                    frase: "La meta de la educación es el avance en el conocimiento y la diseminación de la verdad.",
                    autor: "John F. Kennedy"
                },
                {
                    frase: "La mejor manera de predecir el futuro es creándolo.",
                    autor: "Abraham Lincoln"
                },
                {
                    frase: "El hombre que mueve montañas empieza apartando piedras pequeñas.",
                    autor: "Confucio"
                },
                {
                    frase: "Aprender sin reflexionar es malgastar la energía.",
                    autor: "Confucio"
                },
                {
                    frase: "La educación es el desarrollo en el hombre de toda la perfección de que su naturaleza es capaz.",
                    autor: "Immanuel Kant"
                },
                {
                    frase: "Los sueños no se hacen realidad por arte de magia: requieren sudor, determinación y trabajo duro.",
                    autor: "Colin Powell"
                },
                {
                    frase: "Si quieres aprender, enseña.",
                    autor: "Marco Tulio Cicerón"
                },
                {
                    frase: "Hay una fuerza motriz más poderosa que el vapor, la electricidad y la energía atómica: la voluntad.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "El secreto del éxito está en hacer de tu vocación tu vacación.",
                    autor: "Mark Twain"
                },
                {
                    frase: "Si se siembra la semilla con fe y se cuida con perseverancia, sólo será cuestión de tiempo recoger sus frutos.",
                    autor: "Thomas Carlyle"
                },
                {
                    frase: "No hay ascensor al éxito, hay que tomar las escaleras.",
                    autor: "Zig Ziglar"
                },
                {
                    frase: "La inspiración existe, pero tiene que encontrarte trabajando.",
                    autor: "Pablo Picasso"
                },
                {
                    frase: "Cuando la perseverancia se une con el estudio, pocas son las barreras que no pueden superarse.",
                    autor: "Marie Curie"
                },
                {
                    frase: "En la vida no hay premios ni castigos, sino consecuencias.",
                    autor: "Robert Green Ingersoll"
                },
                {
                    frase: "El éxito consiste en ir de fracaso en fracaso sin perder el entusiasmo.",
                    autor: "Winston Churchill"
                },
                {
                    frase: "Lo importante no es lo que sabes, sino lo que haces con lo que sabes.",
                    autor: "Aldous Huxley"
                },
                {
                    frase: "El verdadero progreso es el que pone la tecnología al alcance de todos.",
                    autor: "Henry Ford"
                },
                {
                    frase: "El futuro pertenece a quienes creen en la belleza de sus sueños.",
                    autor: "Eleanor Roosevelt"
                },
                {
                    frase: "No es lo que te ocurre, sino cómo reaccionas lo que importa.",
                    autor: "Epicteto"
                },
                {
                    frase: "El conocimiento es poder, pero el entusiasmo es el interruptor.",
                    autor: "Ivern Ball"
                },
                {
                    frase: "Aprender es como remar contra corriente: en cuanto se deja, se retrocede.",
                    autor: "Edward Benjamin Britten"
                },
                {
                    frase: "Si buscas resultados distintos, no hagas siempre lo mismo.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "El mayor enemigo del conocimiento no es la ignorancia, es la ilusión del conocimiento.",
                    autor: "Stephen Hawking"
                },
                {
                    frase: "Cada día sabemos más y entendemos menos.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "El genio se hace con un 1% de talento y un 99% de trabajo.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "La educación es nuestra pasaporte para el futuro, porque el mañana pertenece a la gente que se prepara para el hoy.",
                    autor: "Malcolm X"
                },
                {
                    frase: "La causa de la mayoría de los problemas de la gente es que pueden pasar toda su vida sin tener que pensar.",
                    autor: "Robert Kiyosaki"
                },
                {
                    frase: "No hay que confundir nunca el conocimiento con la sabiduría. El primero nos sirve para ganarnos la vida; la sabiduría nos ayuda a vivir.",
                    autor: "Sorcha Carey"
                },
                {
                    frase: "La educación es el movimiento de la oscuridad a la luz.",
                    autor: "Allan Bloom"
                },
                {
                    frase: "Lo que hacemos en la vida, tiene su eco en la eternidad.",
                    autor: "Máximo Décimo Meridio"
                },
                {
                    frase: "El único lugar donde el éxito viene antes que el trabajo es en el diccionario.",
                    autor: "Vidal Sassoon"
                },
                {
                    frase: "La lectura hace al hombre completo; la conversación lo hace ágil, el escribir lo hace preciso.",
                    autor: "Francis Bacon"
                },
                {
                    frase: "La mente es como un paracaídas, solo funciona si se abre.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "Cuanto más conozco a la gente, más quiero a mi perro.",
                    autor: "Diógenes"
                },
                {
                    frase: "El verdadero poder es el conocimiento.",
                    autor: "Francis Bacon"
                },
                {
                    frase: "Los sabios son los que buscan la sabiduría; los necios piensan haberla encontrado.",
                    autor: "Napoleón Bonaparte"
                },
                {
                    frase: "No tengo talentos especiales, pero sí soy profundamente curioso.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "Aprende como si fueras a vivir para siempre; vive como si fueras a morir mañana.",
                    autor: "Mahatma Gandhi"
                },
                {
                    frase: "La disciplina es el puente entre metas y logros.",
                    autor: "Jim Rohn"
                },
                {
                    frase: "Todo lo que escuchamos es una opinión, no un hecho. Todo lo que vemos es una perspectiva, no la verdad.",
                    autor: "Marco Aurelio"
                },
                {
                    frase: "El fracaso derrota a los perdedores, pero inspira a los ganadores.",
                    autor: "Robert T. Kiyosaki"
                },
                {
                    frase: "La inteligencia consiste no solo en el conocimiento, sino también en la destreza de aplicar los conocimientos en la práctica.",
                    autor: "Aristóteles"
                },
                {
                    frase: "No esperes por el momento perfecto. Toma el momento y hazlo perfecto.",
                    autor: "Zoey Sayward"
                },
                {
                    frase: "Tu tiempo es limitado, así que no lo desperdicies viviendo la vida de otra persona.",
                    autor: "Steve Jobs"
                },
                {
                    frase: "El viaje de mil millas comienza con un solo paso.",
                    autor: "Lao Tse"
                },
                {
                    frase: "La mejor manera de aprender es enseñar.",
                    autor: "Cicerón"
                },
                {
                    frase: "Las mentes son como los paracaídas, solo funcionan cuando están abiertas.",
                    autor: "James Dewar"
                },
                {
                    frase: "Los logros de una organización son los resultados del esfuerzo combinado de cada individuo.",
                    autor: "Vince Lombardi"
                },
                {
                    frase: "La actividad más importante que un ser humano puede lograr es aprender para entender, porque entender es ser libre.",
                    autor: "Baruch Spinoza"
                },
                {
                    frase: "La única manera de hacer un gran trabajo es amar lo que haces.",
                    autor: "Steve Jobs"
                },
                {
                    frase: "No hay secretos para el éxito. Es el resultado de la preparación, trabajo duro y aprender del fracaso.",
                    autor: "Colin Powell"
                },
                {
                    frase: "El mayor riesgo es no correr ningún riesgo. En un mundo que cambia muy rápidamente, la única estrategia que garantiza fracasar es no tomar riesgos.",
                    autor: "Mark Zuckerberg"
                },
                {
                    frase: "La educación es la llave para abrir la puerta dorada de la libertad.",
                    autor: "George Washington Carver"
                },
                {
                    frase: "Un libro abierto es un cerebro que habla; cerrado, un amigo que espera; olvidado, un alma que perdona; destruido, un corazón que llora.",
                    autor: "Proverbio hindú"
                },
                {
                    frase: "La paciencia es amarga, pero su fruto es dulce.",
                    autor: "Jean-Jacques Rousseau"
                },
                {
                    frase: "El futuro tiene muchos nombres: para los débiles, lo inalcanzable; para los temerosos, lo desconocido; para los valientes, la oportunidad.",
                    autor: "Víctor Hugo"
                },
                {
                    frase: "El éxito no es definitivo, el fracaso no es fatídico. Lo que cuenta es el valor para continuar.",
                    autor: "Winston Churchill"
                },
                {
                    frase: "Cuando escribas la historia de tu vida, no dejes que nadie más sostenga el bolígrafo.",
                    autor: "Harley Davidson"
                },
                {
                    frase: "La educación es el arma más poderosa que puedes usar para cambiar el mundo.",
                    autor: "Nelson Mandela"
                },
                {
                    frase: "La educación no cambia el mundo, cambia a las personas que van a cambiar el mundo.",
                    autor: "Paulo Freire"
                },
                {
                    frase: "El objetivo de la educación es la virtud y el deseo de convertirse en un buen ciudadano.",
                    autor: "Platón"
                },
                {
                    frase: "El propósito de la educación es reemplazar una mente vacía con una abierta.",
                    autor: "Malcolm Forbes"
                },
                {
                    frase: "La ignorancia afirma o niega rotundamente; la ciencia duda.",
                    autor: "Voltaire"
                },
                {
                    frase: "La educación es el arte de hacer que el hombre se descubra a sí mismo.",
                    autor: "Jean-Jacques Rousseau"
                },
                {
                    frase: "El aprendizaje es experiencia, todo lo demás es información.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "El mundo es un libro y aquellos que no viajan solo leen una página.",
                    autor: "San Agustín"
                },
                {
                    frase: "Cuanto más sabes, más te das cuenta de que no sabes nada.",
                    autor: "Sócrates"
                },
                {
                    frase: "Un libro debe ser el hacha que rompa el mar helado que hay dentro de nosotros.",
                    autor: "Franz Kafka"
                },
                {
                    frase: "Si no estás dispuesto a aprender, nadie puede ayudarte. Si estás decidido a aprender, nadie puede detenerte.",
                    autor: "Zig Ziglar"
                },
                {
                    frase: "La enseñanza que deja huella no es la que se hace de cabeza a cabeza, sino de corazón a corazón.",
                    autor: "Howard G. Hendricks"
                },
                {
                    frase: "La educación es el desarrollo en el hombre de toda la perfección de que su naturaleza es capaz.",
                    autor: "Immanuel Kant"
                },
                {
                    frase: "La educación es la vacuna contra la violencia.",
                    autor: "Edward James Olmos"
                },
                {
                    frase: "El conocimiento descansa no solo en la verdad sino también en el error.",
                    autor: "Carl Jung"
                },
                {
                    frase: "Vivir sin filosofar es, propiamente, tener los ojos cerrados, sin tratar de abrirlos jamás.",
                    autor: "René Descartes"
                },
                {
                    frase: "El verdadero signo de la inteligencia no es el conocimiento sino la imaginación.",
                    autor: "Albert Einstein"
                },
                {
                    frase: "Es imposible para un hombre aprender lo que cree que ya sabe.",
                    autor: "Epicteto"
                },
                {
                    frase: "Nunca he dejado que la escuela entorpezca mi educación.",
                    autor: "Mark Twain"
                }
            ]
        }
    },
    computed: {
        currentPhrase() {
            return this.motivationPhrases[this.currentIndex];
        }
    },
    methods: {
        nextPhrase() {
            this.currentIndex = (this.currentIndex + 1) % this.motivationPhrases.length;
        },
        randomPhrase() {
            this.currentIndex = Math.floor(Math.random() * this.motivationPhrases.length);
        }
    },
    mounted() {
        // Iniciar con una frase aleatoria
        this.randomPhrase();
        
        // Cambiar la frase cada 8 segundos
        this.interval = setInterval(() => {
            this.nextPhrase();
        }, 8000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}
</script>

<style scoped>
.motivation-container {
    padding: 20px;
    max-width: 500px;
    margin: 0 auto;
}

.motivation-phrase-content {
    background-color: #f8f9fa;
    border-radius: 12px;
    border-left: 4px solid #4dd453;
    padding: 16px;
    transition: all 0.3s ease;
}

.motivation-phrase {
    font-size: 1.1rem;
    line-height: 1.5;
    color: #333;
    margin-bottom: 10px;
}

.motivation-author {
    font-size: 0.9rem;
    color: #666;
    text-align: right;
    margin-bottom: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>


